export enum EnumTaskStatus {
  WAITING = -1, // 准备中
  PADDING = 0, // 待处理
  PROGRESSING = 1, // 处理中
  SUCCESS = 2, // 处理成功
  FAIL = 3, // 处理失败
}

export enum EnumTaskAssetsType {
  IMAGE = 1,
  AUDIO = 2,
  VIDEO = 3,
  TEXT = 4,
}

//关联任务类型 1:编辑器素材导出 2:AI人脸替换 3:AIVideo视频 4:AI绘画 5:AITTS 6:TTSClone
export enum EnumTaskClientType {
  IDE = 1,
  AI_FACE = 2,
  AI_VIDEO = 3,
  AI_DRAW = 4,
  AI_TTS = 5,
  AI_TTS_CLONE = 6,
  AI_MUSIC = 7,
}
